<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <!--      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>-->
      <!--        <el-row :gutter="15">-->
      <!--          <el-col :md="7" :sm="12">-->
      <!--            <el-form-item label="登录日期:">-->
      <!--              <el-date-picker-->
      <!--                v-model="daterange"-->
      <!--                type="daterange"-->
      <!--                range-separator="至"-->
      <!--                start-placeholder="开始日期"-->
      <!--                end-placeholder="结束日期"-->
      <!--                class="ele-fluid"-->
      <!--                @change="onDateRangeChoose"-->
      <!--              />-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <!--          <el-col :md="8" :sm="12">-->
      <!--            <div class="ele-form-actions">-->
      <!--              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>-->
      <!--              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>-->
      <!--            </div>-->
      <!--          </el-col>-->
      <!--        </el-row>-->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="addPerson" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加维修人员</el-button>
      </div>
      <!--      </el-form>-->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template>
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column prop="teacherName" label="姓名" show-overflow-tooltip />
          <el-table-column prop="positionType" label="岗位" show-overflow-tooltip />
          <el-table-column prop="mobile" label="电话" show-overflow-tooltip />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="editPerson(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
              <el-popconfirm title="确定要删除此维修人员吗？" @onConfirm="deletePerson(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改维修人员' : '添加维修人员'"
      :visible.sync="showEdit"
      width="400px"
      @closed="resetPersonForm"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="岗位" prop="typeId">
          <el-select v-model="editForm.typeId" placeholder="请选择岗位">
            <el-option v-for="item in postList" :key="item.id" :label="item.positionName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="教师" prop="teacherId">
          <el-select
            v-model="editForm.teacherId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入教师名称关键词"
            :remote-method="getTeacherList"
            @change="selectTeacher"
            :loading="loading"
          >
            <el-option v-for="item in teacherList" :key="item.id" :label="item.teacherName" :value="item.id">
              <span style="float: left">{{ item.teacherName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mobile }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话:" prop="mobile">
          <el-input v-model="editForm.mobile" placeholder="请输入电话" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="savePerson(editForm.personId)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { repairPersonDelete, repairPersonSet, repairPersonUpdate, getRepairPositionListNoPage, getTeacherList } from '@/config/fengyi/api';
  export default {
    name: 'Person',
    data() {
      return {
        table: {
          // 表格配置
          url: '/fy/setting/getRepairPersonList',
          method: 'GET',
          where: {},
          page:false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [],
        editForm: {
          mobile: null,
          teacherId: null,
          typeId: null,
        },
        editRules: {
          mobile: [{ required: true, message: '请输入电话号码', trigger: 'blur' }],
          teacherId: [{ required: true, message: '请选择教师', trigger: 'change' }],
          typeId: [{ required: true, message: '请选择岗位', trigger: 'change' }],
        },
        showEdit: false,
        postList: [], //岗位列表
        teacherList: [],
        loading: false,
      };
    },
    methods: {
      // 打开添加维修人员弹窗
      addPerson() {
        this.getPostList();
        this.getTeacherList();
        this.showEdit = true;
      },
      // 编辑维修人员
      editPerson(row) {
        this.getPostList();
        this.getTeacherList();
        this.editForm = Object.assign({}, row);
        this.editForm.teacherId = row.personId;
        this.showEdit = true;
      },
      // 保存或更新
      savePerson(id) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (id == undefined) {
              //添加
              repairPersonSet(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //编辑
              repairPersonUpdate(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除维修人员
      deletePerson(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        repairPersonDelete(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 重置表单
      resetPersonForm() {
        this.editForm = {
          mobile: null,
          teacherId: null,
          typeId: null,
        };
        this.$refs['editForm'].resetFields();
      },
      // 获取岗位列表
      getPostList() {
        getRepairPositionListNoPage().then((res) => {
          if (res.data.resCode == 200) {
            this.postList = res.data.data;
          }
        });
      },
      // 获取教师列表
      getTeacherList(name) {
        this.loading = true;
        getTeacherList({ teacherName: name }).then((res) => {
          if (res.data.resCode == 200) {
            this.teacherList = res.data.data;
            this.loading = false;
          }
        });
      },
      // 选择教师
      selectTeacher(value) {
        let teacher = this.teacherList.find((item) => item.id == value);
        this.editForm.teacherName = teacher.teacherName;
        this.editForm.mobile = teacher.mobile;
      },
    },
  };
</script>

<style scoped></style>
